"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from "react";
import { CenterAligned } from "../CenterAligned";
import { RetryButton } from "../RetryButton";
import { useScrollingPagination } from "./useScrollingPagination";
export function ScrollingPaginator(t0) {
  const $ = _c(16);
  const {
    renderFallback: Fallback,
    hasNext,
    loadNext,
    isLoadingNext,
    hasError: hasErrorProp
  } = t0;
  const [hasLocalError, setHasLocalError] = useState(false);
  const hasError = hasErrorProp || hasLocalError;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setHasLocalError(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onError = t1;
  const t2 = hasNext && !hasLocalError;
  let t3;
  if ($[1] !== isLoadingNext || $[2] !== loadNext || $[3] !== t2) {
    t3 = {
      hasNext: t2,
      loadNext,
      isLoadingNext,
      onError
    };
    $[1] = isLoadingNext;
    $[2] = loadNext;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    ref,
    isLoading
  } = useScrollingPagination(t3);
  let t4;
  if ($[5] !== Fallback || $[6] !== hasError || $[7] !== hasErrorProp || $[8] !== isLoading || $[9] !== loadNext) {
    t4 = () => {
      if (hasError || hasErrorProp) {
        return <CenterAligned className="my-4"><RetryButton onClick={async () => {
            await loadNext();
            setHasLocalError(false);
          }} /></CenterAligned>;
      }
      if (!isLoading) {
        return <div style={{
          height: "1px"
        }} />;
      }
      if (Fallback) {
        return <Fallback />;
      }
      return null;
    };
    $[5] = Fallback;
    $[6] = hasError;
    $[7] = hasErrorProp;
    $[8] = isLoading;
    $[9] = loadNext;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const renderContent = t4;
  let t5;
  if ($[11] !== renderContent) {
    t5 = renderContent();
    $[11] = renderContent;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== ref || $[14] !== t5) {
    t6 = <div ref={ref}>{t5}</div>;
    $[13] = ref;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}